import type { LinkProps } from '@mui/material/Link';

import { useId } from 'react';
import { mergeClasses } from 'minimal-shared/utils';

import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';
import {CONFIG} from "../../global-config";

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
  width?: number;
  height?: number;
};


export function Logo({
                       sx,
                       disabled,
                       className,
                       href = '/',
                       isSingle = true,
                       width,
                       height,
                       ...other
                     }: LogoProps) {
  const theme = useTheme();

  const gradientId = useId();

  const TEXT_PRIMARY = theme.vars.palette.text.primary;
  const PRIMARY_LIGHT = theme.vars.palette.primary.light;
  const PRIMARY_MAIN = theme.vars.palette.primary.main;
  const PRIMARY_DARKER = theme.vars.palette.primary.dark;

  const singleLogo = (
    <img
      alt="The Financial Adviser"
      src={`${CONFIG.assetsDir}/logo/icona.jpg`}
      width="100%"
      height="100%"
    />
  );

  const fullLogo = (
    <img
      alt="The Financial Adviser"
      src={`${CONFIG.assetsDir}/logo/logo.png`}
      width="100%"
      height="100%"
    />
  );

  const defaultWidth = isSingle ? 40 : 102;
  const defaultHeight = isSingle ? 40 : 36;

  return (<></>);

 /* return (
    <LogoRoot
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: width ?? defaultWidth,
          height: height ?? defaultHeight,
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {isSingle ? singleLogo : fullLogo}
    </LogoRoot>
  );*/
}


// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
